export default __webpack_public_path__ + "static/media/File9.f0429e1b.pdf";